import { Button, Grid2 } from "@mui/material";
import Header from "Components/Common/Header";
import React from "react";
import { ReactComponent as SupportIcon } from "Assets/Icons/Home/SupportIcon.svg";
import NextIcon from "Assets/Icons/Home/NextIcon.svg";
import PrevIcon from "Assets/Icons/Home/PrevIcon.svg";
import PrimaryIcon from "Components/Common/PrimaryIcon";
import HomeBackgroundLeftTop from "Assets/Backgrounds/home-background-left-top.png";
import HomeBackgroundRightTop from "Assets/Backgrounds/home-background-right-top.png";
import HomeBackgroundLeftBottom from "Assets/Backgrounds/home-background-left-bottom.png";
import HomeBackgroundRightBottom from "Assets/Backgrounds/home-background-right-bottom.png";
import ReferralFooter from "Components/Common/ReferralFooter";
import { Navigate, useLocation } from "react-router-dom";
import Cookies from 'js-cookie';
import { useSelector } from "react-redux";
import zIndex from "@mui/material/styles/zIndex";

const styles = (theme) => ({
  // padding: "15px 24px",
  "& .support": {
    position: "fixed",
    right: "10px",
    bottom: "10px",
    zIndex: 5,
  },

  // Global Swiper Styles
  "& .swiper-button-next, & .swiper-button-prev": {
    backgroundColor: theme.palette.primary.main,
    borderRadius: "50%",
    height: "32px",
    width: "32px",
    opacity: 1,
    backgroundRepeat: "no-repeat",
    backgroundPosition: "center",
    backgroundSize: "20px",
    marginTop: "calc(0px - 16px)",
    "&::after": {
      content: '""',
    },
  },
  "& .swiper-button-next": {
    backgroundImage: `url(${NextIcon})`,
    transform: theme.direction === "rtl" ? "rotate(180deg)" : "none",
  },
  "& .swiper-button-prev": {
    backgroundImage: `url(${PrevIcon})`,
    transform: theme.direction === "rtl" ? "rotate(180deg)" : "none",
  },
  "& .swiper-button-disabled": {
    display: "none",
  },
});

const ProtectedLayout = ({ children }) => {
  const token = Cookies.get("authorization");
  const location = useLocation();

  const { Translation } = useSelector((state) => ({
    Translation: state.Translation.translation?.Common || {},
  }));

  if (!token) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  const isReferralRoute = location.pathname.includes("/invite-friends");

  return (
    <>
      <Header />
      <Grid2 sx={(theme) => styles(theme)}>
        {children}{" "}
        <Button
          startIcon={<PrimaryIcon color="white" icon={SupportIcon} />}
          className="support"
          color="error"
          variant="contained"
        >
          {Translation?.CodedSupport}
        </Button>
      </Grid2>
      {isReferralRoute && <ReferralFooter />}
    </>
  );
};

export default ProtectedLayout;
